<template id="template-checkbox">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :label="label"
      :isHidden="isHidden"
      v-on:toggle-field="showSettings = !showSettings"
      v-on:collapse-field="collapse = !collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />

    <b-collapse
      :class="isPreview ? 'mt-1' : 'mt-5'"
      id="collapse-1"
      v-model="collapse"
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
    >
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional == '1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :id="fieldData.id"
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="fieldData.validationMessage[selectedLanguage]"
          >
            <label>
              <span
                v-if="
                  fieldData.validation &&
                    JSON.parse(fieldData.validation.required)
                "
                class="required-span"
                >*</span
              >
              {{
                form1.enableSectionFieldEnumeration == 1
                  ? sectionIndex + 1 + "." + (fieldIndex + 1)
                  : ""
              }}
              {{ label ? label : fieldData.label[selectedLanguage] }}
            </label>
            <!-- <div class="clearfix"></div> -->
            <b-form-checkbox-group
              :stacked="fieldData.configuration.isStacked"
              :id="fieldData.id"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              v-model="selectedChekboxes"
              :options="renderOptions"
              :disabled="isValidateLength || isDisabled == 1"
              disabled-field="disabled"
              @input="checkCondition"
            ></b-form-checkbox-group>
            <!-- <b-form-checkbox
              v-if="fieldData.isDisableOpt == 1"
            >I accept the terms and use</b-form-checkbox>-->
            <label
              v-if="
                fieldData.validation &&
                  fieldData.validation.required == 1 &&
                  !selectedChekboxes &&
                  isFocus
              "
              class="text-danger"
              >{{ fieldData.validationMessage[selectedLanguage] }}</label
            >
            <label v-if="showMinAlert" class="text-danger"
              >Please select atleast
              {{ fieldData.validation.minSelect }} option/s</label
            >
            <label v-if="showMaxAlert" class="text-danger"
              >Please select {{ fieldData.validation.maxSelect }} option/s
              only.</label
            >
          </b-form-group>

          <!-- conditional input field -->
          <b-collapse v-model="showCollapseField" class="mt-2">
            <!-- v-show="conditionalFieldIsVisible == 1" -->
            <b-form-group
              :class="
                $store.state.rightAlign ? 'text-right ml-3 ' : 'text-left ml-3'
              "
              :description="
                fieldData.conditionalFieldHelperText[selectedLanguage]
              "
              :label="fieldData.conditionalFieldLabel[selectedLanguage]"
              :invalid-feedback="msg.xss ? $t('createProfile.invalidInputMessage') : $t('createProfile.requiredValidationMessage')"
            >
              <b-form-textarea
                v-model="conditionalFieldInputValue"
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                @input="onInputType"
                :disabled="isDisabled == 1"
                :placeholder="
                  fieldData.conditionalFieldPlaceHolderText[selectedLanguage]
                "
                :rows="fieldData.conditionalFieldMinRows || 3"
                :max-rows="fieldData.conditionalFieldMaxRows || 6"
                :state="
                  msg.xss
                    ? false
                    : isFocus &&
                      conditionalFieldInputValue &&
                      isMatchCondition &&
                      fieldData.validation.required == 1
                    ? true
                    : false
                "
                @focus="isFocus = true"
              ></b-form-textarea>
            </b-form-group>
          </b-collapse>
        </b-col>
      </b-row>

      <!-- advanced settings tab -->
      <b-modal
        cancel-title="Close"
        ok-title="save"
        @ok="onSaveData"
        @hidden="onUpdateSettings"
        size="xl"
        v-model="showSettings"
        title="Checkbox Settings"
      >
        <AdvanceCheckboxSettings
          v-if="showSettings"
          :fieldData="fieldData"
          v-on:toggle-field="showSettings = !showSettings"
          :sectionIndex="sectionIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import _ from "lodash";
// import AdvanceCheckboxSettings from "../advanceCheckboxSettingsComponent";
import AdvanceCheckboxSettings from "../advanceRadioSettingsComponent.vue";
import MenuButtons from "../menuButtons";
import { EventBus } from "@/event-bus.js";
import { Validate } from "../../helpers";
import { invalid } from "moment";
import { componentsPlugin } from "bootstrap-vue";
export default {
  name: "CheckboxGroup",
  components: {
    AdvanceCheckboxSettings,
    MenuButtons,
  },
  data() {
    return {
      isHidden: false,
      isFocus: false,
      condition: {},
      showSettings: false,
      isRequired: 1,
      collapse: true,
      label: undefined,
      placeholder: undefined,
      helperText: undefined,
      renderOptions: [],
      isValidateLength: false,
      showMinAlert: false,
      showMaxAlert: false,
      selectedChekboxes: this.fieldData.selected || [],
      cc: null,
      conditionalFieldLabel: null,
      conditionalFieldHelperText: null,
      conditionalFieldPlaceHolderText: null,
      conditionalFieldValidationMessage: null,
      conditionalFieldIsRequired: 0,
      conditionalFieldMaxRows: 1,
      conditionalFieldInputValue: null,
      conditionalFieldPostName: null,
      conditionalFieldIsVisible: 0,
      showCollapseField: false,
      isMatchCondition: false,
      msg: {},
    };
  },

  validations: {
    name: {
      required,
    },
  },

  mounted() {
    this.isRequired = this.fieldData.validation.required;
    let getOptions = this.fieldData.options;
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setFieldValue();
    }

    getOptions.map((option) => {
      let newOption = {
        value: option.value,
        text: option.text[this.selectedLanguage] || "No Text Set",
        disabled: false,
      };
      this.renderOptions.push(newOption);
    });

    // this.conditionalFieldIsVisible = this.fieldData.conditionalFieldIsVisible;
  },

  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.$store.state.validFields = false;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      }
      // console.log("isHidden", this.fieldData)
      if (this.fieldData.isHidden) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
        this.fieldData.validation.required = 0;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (!this.selectedChekboxes || !this.selectedChekboxes.length) {
            this.isFocus = true;
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
          } else if (this.selectedChekboxes && this.selectedChekboxes.length) {
            if (this.isMatchCondition) {
              if (!this.conditionalFieldInputValue) {
                this.isFocus = true;
                this.$store.state.validFields = false;
                this.fieldData.isInValid = true;
              } else {
                this.$store.state.validFields = true;
                this.fieldData.isInValid = false;
              }
            }
          } else {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;
          }
        }
      }
    });
    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      if (inValidData && inValidData.elementId) {
        document
          .getElementById(inValidData.elementId)
          .scrollIntoView({ behavior: "smooth" });
      }
    });

    EventBus.$on("onUpdateCheckboxValues", (value) => {
      this.selectedChekboxes = [];
    });

    EventBus.$on("onResetCheckBox", (value) => {
      this.resetPregressiveElement(value);
    });
    EventBus.$on("onResetSelectedValues", (value) => {
      this.resetSelectedValues(value);
    });
  },

  computed: {
    ...mapGetters(["form1", "selectedLanguage", "userFormSubmitArray"]),
    ...mapState(["toggleAllCoppalse"]),
  },

  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),

    onUpdateSettings() {
      this.TOGGLE_LOADER(50);
    },

    calculateScoring() {
      let score = null;
      // console.log("this.selectedChekboxes", this.fieldData.disableOptions);
      let isFoundDisableOpt = false;
      let selectedOption = this.selectedChekboxes.find((ele) => ele);
      if (
        this.fieldData.disableOptions &&
        this.fieldData.disableOptions.length
      ) {
        isFoundDisableOpt = this.fieldData.disableOptions.some(
          (opt) => opt.value == selectedOption
        );
      }
      let length = this.selectedChekboxes.length;
      let ranges =
        this.fieldData.ranges && this.fieldData.ranges.length
          ? this.fieldData.ranges
          : [];

      if (isFoundDisableOpt) {
        return (score = 1);
      } else if (ranges.length) {
        let range = ranges.map((range) => {
          if (range.minRange <= length && length <= range.maxRange) {
            console.log("range score", range.score);
            return (score = score ? score : range.score);
          }
        });
      } else {
        return (score = 0);
      }

      return score;

      // if (
      //   this.fieldData.customScoringType &&
      //   this.fieldData.customScoringType == 0
      // ) {
      //   switch (true) {
      //     case isFoundDisableOpt:
      //       return 1;
      //       break;
      //     case length > 3:
      //       return 0;
      //       break;
      //     case length <= 3:
      //       return 0;
      //       break;
      //     default:
      //       return 0;
      //   }
      // } else {
      //   switch (true) {
      //     case isFoundDisableOpt:
      //       return 1;
      //       break;
      //     case length <= 3:
      //       return 0.5;
      //       break;
      //     case length <= 3:
      //       return 0;
      //       break;
      //     default:
      //       return 0;
      //   }
      // }
    },

    checkCondition(options) {
      for (let opt of this.renderOptions) opt.disabled = false;
      if (
        options &&
        options.length &&
        this.fieldData.disableOptions &&
        this.fieldData.disableOptions.length
      ) {
        this.fieldData.disableOptions.map((tt) => {
          let foundOpt = options.find((opt) => opt == tt.value);

          if (foundOpt) {
            for (let opt of this.renderOptions)
              if (opt.value != foundOpt) {
                opt.disabled = true;
                const index = options.indexOf(opt.value);
                if (index > -1) {
                  options.splice(index, 1);
                }
              }
          } else {
          }
        });
      }

      this.isFocus = options.length > 0 ? false : true;
      this.$store.state.validFields = true;
      this.fieldData.isInValid = false;

      let elements = this.form1.formSection[this.sectionIndex].formElements;

      let found = elements.find((ff, index) => {
        // console.log("ff.conditions", ff.conditions, options)
        if (ff.conditions && ff.conditions.length) {
          ff.conditions.map((aa) => {
            let selectedValue = options.find((opt) => opt);

            let foundSelected = ff.conditions.some(
              (opt) => opt.value == selectedValue
            );
            // console.log("aa", aa, tt)
            if (
              aa.sourceFieldId === this.fieldData.id &&
              aa.targetFieldId !== this.fieldData.id &&
              // aa.value === selectedValue &&
              foundSelected &&
              aa.label === this.fieldData.label["english"]
            ) {
              console.log("------ condition iffffff check box");
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = false;
              this.enableValidations(
                this.form1.formSection[this.sectionIndex].formElements[index]
              );
            } else if (
              aa.sourceFieldId === this.fieldData.id &&
              aa.targetFieldId !== this.fieldData.id &&
              // aa.value !== selectedValue &&
              !foundSelected &&
              aa.label === this.fieldData.label["english"]
            ) {
              // console.log("------ condition hidden true elseeeee if checkbox");
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = true;

              // console.log("this.form1.formSection[this.sectionIndex].formElements[index]", this.form1.formSection[this.sectionIndex].formElements[index])
              this.disableValidations(
                this.form1.formSection[this.sectionIndex].formElements[index]
              );
            } else {
              // this.form1.formSection[this.sectionIndex].formElements[index].isHidden = true;
            }
          });
        } else {
          // console.log("------  elseeee");
          // this.form1.formSection[this.sectionIndex].formElements[index].isHidden = false;
        }
      });

      // let found, self;
      let field = this.fieldData;
      // elements.map((ff, index) => {
      //   if (ff.conditions && ff.conditions.length) {
      //     ff.conditions.find((currentConditionValue) => {
      //       let indexValue = options.indexOf(currentConditionValue.value);
      //       if (indexValue !== -1) {
      //         let indexId = ff.multiConditions.findIndex(
      //           (q) => q.id === currentConditionValue.sourceFieldId
      //         );
      //         let oo = this.form1.formSection[this.sectionIndex].formElements[
      //           index
      //         ].multiConditions[indexId].isActive;
      //         if (
      //           currentConditionValue.sourceFieldId === field.id &&
      //           currentConditionValue.value === options[indexValue]
      //         ) {
      //           this.form1.formSection[this.sectionIndex].formElements[
      //             index
      //           ].multiConditions[indexId].isActive = true;
      //         } else if (field.id === currentConditionValue.sourceFieldId) {
      //           this.form1.formSection[this.sectionIndex].formElements[
      //             index
      //           ].multiConditions[indexId].isActive = false;
      //         }
      //       }
      //     });
      //   }
      // });

      // check for min options
      if (this.fieldData.validation.minSelect) {
        let minValue = parseInt(this.fieldData.validation.minSelect);
        if (options.length < minValue) {
          // alert("minmun errorr");
          this.showMinAlert = true;
        } else {
          this.showMinAlert = false;
        }
      }

      // check for max options
      if (this.fieldData.validation.maxSelect) {
        let maxValue = parseInt(this.fieldData.validation.maxSelect);
        if (options.length > maxValue) {
          // this.selectedChekboxes.splice(1, 1);
          this.showMaxAlert = true;
        } else {
          this.showMaxAlert = false;
          this.isValidateLength = false;
        }
      }

      // for new conditional fields..
      if (this.fieldData.selectedConditionalFieldValue) {
        let dd = options.includes(this.fieldData.selectedConditionalFieldValue);
        if (dd) {
          this.showCollapseField = true;
          this.conditionalFieldIsVisible = 1;
          this.isMatchCondition = true;
          this.isFocus = true;
        } else {
          this.showCollapseField = false;
          this.conditionalFieldIsVisible = 0;
          // this.conditionalFieldInputValue = null;
          this.isMatchCondition = false;
          this.isFocus = true;
        }
      }

      this.setValue(options);
    },

    // for disable vlaidations
    disableValidations(element) {
      // console.log("disableValidations ,", element);
      switch (element.inputType) {
        case "input":
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                a.elements.map((el) => {
                  // console.log("elllll input", el)
                  return (el.postValue = null);
                  // this.fieldData.isHidden = el.postValue.length ? false: true
                });
              }
            });
          EventBus.$emit("onUpdateInputValues", "");
          break;
        case "radio":
          // console.log("disableValidations checkbox ,", element);

          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                EventBus.$emit("onResetSelectedRadioValues", element);
                a.elements.map((el) => {
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateRadioValues", "");
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              // console.log("el radio", a.label['english']);
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                EventBus.$emit("onResetSelectedRadioValues", element);
                a.elements.map((el) => {
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateRadioValues", "");
              }
            });
          element.isInValid = false;
          element.validation.required = 0;
          // code block

          break;
        case "checkbox":
          // console.log("checkbox")
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 1;
                a.elements.map((el) => {
                  // console.log("el checkbox", el);
                  return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateCheckboxValues", "");
              }
            });
          element.isInValid = false;
          element.validation.required = 0;
          // code block

          break;
        case "individual-shareholders":
          // element.validation.isRequireFreeForm = false;
          // element.validation.isRequireLastName = false;
          // element.validation.isRequireFirstName = false;
          // element.validation.isRequireDateOfBirth = false;
          // element.validation.isRequireCountryOfBirth = false;
          // element.validation.isRequirePassportNumber = false;
          // element.validation.isRequirePercentageOwned = false;
          element.isInValid = false;
          element.validation.required = 0;
          // code block
          break;
        default:
          element.isInValid = false;
          element.validation.required = 0;
        // code block
      }
    },

    enableValidations(element) {
      // console.log("element", element);
      switch (element.inputType) {
        case "individual-shareholders":
          element.isInValid = true;
          // element.validation.required = 1;
          // code block
          break;
        case "radio":
          // console.log("case radio in radio", element);
          this.$store.state.getUserFormSubmitArray.length &&
            this.$store.state.getUserFormSubmitArray.map((a, index) => {
              // console.log("el radio", a.label['english']);
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
                a.elements.map((el) => {
                  // console.log("el radio", a);
                  // this.fieldData.isHidden = el.postValue.length ? false: true
                  // return (el.postValue = null), (el.score = 0);
                });
                // EventBus.$emit("onUpdateRadioValues", "");
              }
            });
          this.$store.state.userFormSubmitArray.length &&
            this.$store.state.userFormSubmitArray.map((a, index) => {
              if (a.elementId == element.id) {
                a.isHiddenElement = 0;
              }
            });

          element.isInValid = false;
          element.validation.required = 0;
          // code block

          break;
        default:
          element.isInValid = true;
          element.validation.required = 1;
        // code block
      }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a && a.elementId && a.elements && a.elements.length) {
            if (a.elementId === this.fieldData.id) {
              a.elements.map((el) => {
                if (el.key == "checkbox") {
                  this.selectedChekboxes = el.postValue;
                } else if (el.key == "progressive") {
                  this.conditionalFieldInputValue = el.postValue;
                }
              });
            }
          }
        });
      this.setConditionInput();
    },

    setConditionInput() {
      if (
        this.selectedChekboxes &&
        this.selectedChekboxes.length &&
        this.fieldData.selectedConditionalFieldValue
      ) {
        let dd = this.selectedChekboxes.includes(
          this.fieldData.selectedConditionalFieldValue
        );
        if (dd) {
          this.showCollapseField = true;
          this.conditionalFieldIsVisible = 1;
          this.isMatchCondition = true;
          this.isFocus = true;
        } else {
          this.showCollapseField = false;
          this.fieldData.selectedConditionalFieldValue = null;
          this.conditionalFieldIsVisible = 0;
          this.isMatchCondition = false;
          this.isFocus = false;
        }
      }
    },

    setValue(e) {
      let score = 0,
        accumalatedScoring = 0;
      const registerData = _.clone(this.$store.state.registerData);
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.selectedChekboxes = e;

        if (e && e.length > 0) {
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        this.$store.state.progressValue = numkeys;
        let option = undefined,
          postText = [];
        this.selectedChekboxes.map((chk) => {
          option = this.fieldData.options.find(
            (opt) => opt.text[this.selectedLanguage] == chk
          );
          if (option && option.text) {
            postText.push(option.text[this.selectedLanguage]);
          }
          if (option && option.score) {
            score = option.score;
          }
        });
        // console.log("postText", postText);
        // console.log("option", option);
        // this.fieldData.customScoring &&

        if (this.fieldData.ranges && this.fieldData.ranges.length) {
          accumalatedScoring = this.calculateScoring();
        } else {
          accumalatedScoring = score;
        }
        console.log("accumalatedScoring", accumalatedScoring);

        // console.log("this.selectedChekboxes", this.selectedChekboxes);
        // console.log("this.this.fieldData.options", this.fieldData.options);
        let selectedCheckboxOptionsPostValueAbb = [];
        let selectedCheckboxOptionsCustomValues = [];
        this.selectedChekboxes.map((chk) => {
          let option = this.fieldData.options.find(
            (opt) => opt.text[this.selectedLanguage] == chk
          );
          selectedCheckboxOptionsPostValueAbb.push(
            (option && option.postValueAbb) || null
          );
          selectedCheckboxOptionsCustomValues.push(
            (option && option.custom_values) || null
          );
          // console.log("option", option.score)
          // score.push(option.score)
        });
        this.$store.state.userFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements[0] = {
              postValue: this.selectedChekboxes,
              postValueText: postText || null,
              postValueAbb: selectedCheckboxOptionsPostValueAbb,
              key: "checkbox",
              score: accumalatedScoring,
              custom_values: selectedCheckboxOptionsCustomValues,
              postName:
                (this.fieldData.attributes &&
                  this.fieldData.attributes.postName) ||
                "postNameCheckbox",
            };
          }
        });

        // Object.assign(this.userForm, data);
        // }
      }
    },

    checkXss(value) {
      if (!Validate.noXSS(value)) {
        this.msg["xss"] = true;
        return true;
      }
      this.msg["xss"] = false;
      return false;
    },

    hasActiveXssError() {
      return Object.keys(this.msg).some((key) => key.startsWith("xss") && this.msg[key]);
    },

    onInputType(e) {
      const hasXss = this.checkXss(e);
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        (this.$route.name == "ViewComplaints" && this.showCollapseField)
      ) {
        if (!hasXss) {
          this.$store.state.userFormSubmitArray.map((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[1] = {
                postValue: e,
                key: "progressive",
                postNameProgressive:
                  this.fieldData.conditionalFieldLabel || "postNameProgressive",
              };
            }
          });
        }
      }
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
    },

    resetSelectedValues(selectedElement) {
      if (selectedElement.id === this.fieldData.id) {
        this.selectedChekboxes = [];
      }
    },

    resetPregressiveElement(selectedElement) {
      let foundSection = this.form1.formSection[selectedElement.sectionIndex]
        .formElements;

      for (let element of foundSection) {
        if (element.id == this.fieldData.id) {
          this.selectedChekboxes = [];
        }
        if (
          element.conditions.length &&
          element.id != this.fieldData.id &&
          element.inputType == "checkbox"
        ) {
          // this.selected = "";
          element.isHidden = true;
        }

        if (
          element.conditions.length &&
          element.id != this.fieldData.id &&
          element.inputType == "radio"
        ) {
          // this.selected = "";
          element.selected = null;
          // element.isHidden = true;
        }
      }
    },
  },
  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
